var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w-full h-16 flex items-center justify-center z-50 bg-white border-t border-grey-light"},[_vm._v("\n  © Copyright by Pathao Ltd.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }